import { Capacitor, registerPlugin } from '@capacitor/core';

/**
 * Le nombre peint sur l'icone de l'application.
 *
 * Le serveur le pose a chaque notification envoyee, ce qui suffit tant
 * qu'on est dehors. Mais rien ne le retire quand on rentre : on lit ses
 * messages, on regarde la cloche, et l'icone continue d'annoncer trois
 * choses qui n'attendent plus. C'est le role de ce greffon — l'ecran
 * connait le compte a la seconde pres, il le redit au systeme.
 *
 * iOS seulement. Android peint sa pastille a partir des notifications
 * posees dans le tiroir, que le systeme retire tout seul ; il n'y a pas
 * d'API pour la corriger depuis l'application, et il n'y en a pas besoin.
 */

interface Pastille {
  poser(options: { nombre: number }): Promise<void>;
}

const greffon = registerPlugin<Pastille>('Pastille');

export async function poserLaPastille(nombre: number): Promise<void> {
  if (Capacitor.getPlatform() !== 'ios') return;
  if (!Capacitor.isPluginAvailable('Pastille')) return;
  /* Une pastille qui ne se pose pas n'est pas une raison de casser
     l'ecran qui la demandait. */
  await greffon.poser({ nombre: Math.max(0, Math.round(nombre)) }).catch(() => undefined);
}
